import React from 'react';
import { Box } from '@tanium/react-box';
import { Trans } from './localization';
import { ErrorFill, ErrorText } from './themeDefinitions';

interface Props {
  /** Children to wrap with an error boundary. */
  children?: React.ReactNode;
  /** A custom wrapper component for the error message. */
  as?: React.ComponentPropsWithoutRef<typeof Box>['as'];
}

interface State {
  isCrashed: boolean;
}

/**
 * Component used to display inline error messages in the event of a catastrophic failure. Should be
 * used very rarely.
 */
export class InlineErrorBoundary extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {
      isCrashed: false,
    };
  }

  public componentDidCatch() {
    // Display fallback UI
    this.setState({ isCrashed: true });
  }

  public render() {
    if (this.state.isCrashed) {
      return (
        <Box as={this.props.as} m={1} p={1} color={ErrorText} bg={ErrorFill}>
          <Trans>The date picker had an unrecoverable error.</Trans>
        </Box>
      );
    }

    return this.props.children;
  }
}
